export class Anchor {
	constructor() {
		this.anchorLinks = document.querySelectorAll('a[href^="/#"]');
		this.anchorLinksArr = Array.prototype.slice.call(this.anchorLinks);
		this.headerHeight = document.querySelector('.header-area').offsetHeight;
		
		//ヘッダーのアンカークリック時
		this.anchorLinksArr.forEach(link => {
			link.addEventListener('click', e => {
				e.preventDefault();
				const targetId = link.hash.replace('/', '');
				this.anchor(targetId);
			});
		});

		//他ページから遷移してきた場合
		document.addEventListener("DOMContentLoaded", () => {
			if (location.hash) {
				setTimeout(() => {
					this.anchor(location.hash);
				},100)
			}
		});
	}

	anchor(hash) {
		const targetElement = document.querySelector(hash);
		const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top - 30;
		window.scrollTo(0, targetOffsetTop - this.headerHeight,);
	}
}